import {useEffect, useState} from 'react';

import {isString} from 'utils/object';

const DefaultConfig = {};

export const useIntersectionObserver = (elementRef, config = DefaultConfig) => {
    const {threshold = 0, root = null, rootMargin = '0%'} = config;
    const [entry, setEntry] = useState(null);

    useEffect(() => {
        if (!window.IntersectionObserver) return;

        const node = elementRef.current;

        if (!node) return;

        const updateEntry = ([entry]) => setEntry(entry);
        const observerParams = {threshold, root, rootMargin};
        const observer = new IntersectionObserver(updateEntry, observerParams);

        observer.observe(node);

        return () => observer.disconnect();

    }, [elementRef, threshold, root, rootMargin]);

    return entry;
};

const EmptyBoundingClientRect = {};

const getElement = observable => {
    if (observable === null) return null;
    if (observable instanceof HTMLElement) return observable;
    if (isString(observable)) return document.querySelector(observable);

    return observable.current;
};

export const useBoundingClientRect = observable => {
    const [boundingClientRect, setBoundingClientRect] = useState(EmptyBoundingClientRect);

    useEffect(
        () => {
            const element = getElement(observable);

            if (!element) return setBoundingClientRect(EmptyBoundingClientRect);

            const boundingClientRect = element.getBoundingClientRect();

            setBoundingClientRect(boundingClientRect);

            const observer = new ResizeObserver(([entry]) => {
                setBoundingClientRect(entry.contentRect);
            });

            observer.observe(element);

            return () => {
                observer.unobserve(element);
            };
        },
        [observable],
    );

    return boundingClientRect;
};

export const useBodyClass = className => {
    const {body} = document;

    return useEffect(
        () => {
            if (!className) return;

            body.classList.add(className);

            return () => body.classList.remove(className);
        },
        [className, body],
    );
};

export const useNavBarHeight = () => {
    const {height: navBarHeight = 0} = useBoundingClientRect('.navbar');

    return navBarHeight;
};
